export default {
  SET_ACTIVE_QUESTION(state, payload) {
    state.activeQuestionIndex = payload
  }
}
